export default __webpack_public_path__ + "static/media/ERTHA.ed4d059b.png";